import * as S from './styled'

const BarcodeDisclaimerCard = () => (
  <S.Wrapper>
    <S.Section>
      <S.Title>Pagamento</S.Title>
      <S.List>
        <S.ListItem>O pagamento do boleto não pode ser parcelado.</S.ListItem>
        <S.ListItem>
          Lembre-se de que a confirmação de pagamento pode levar até 3 dias
          úteis.
        </S.ListItem>
        <S.ListItem>
          Em caso de não pagamento até a data de vencimento, realizaremos o
          cancelamento automático do pedido.
        </S.ListItem>
        <S.ListItem>
          O boleto é válido somente para este pedido. Para repetir a compra você
          deve realizar um novo pedido.
        </S.ListItem>
      </S.List>
    </S.Section>

    <S.Section>
      <S.Title>Entrega</S.Title>
      <S.List>
        <S.ListItem>
          O prazo de entrega dos pedidos com boleto começa a contar a partir da
          confirmação do pagamento pela instituição financeira.
        </S.ListItem>
      </S.List>
    </S.Section>

    <div>
      <S.Title>Acesso</S.Title>
      <S.List>
        <S.ListItem>
          Você poderá acessar o seu boleto através da página &quot;Meus
          Pedidos&quot;.
        </S.ListItem>
      </S.List>
    </div>
  </S.Wrapper>
)

export default BarcodeDisclaimerCard
